import { Card, Stack } from '@mui/material';

import { OverdueListPage } from '@app/modules/overdueTasks';

const EmployeeOverdueTasks = () => {
  return (
    <>
      <Card sx={{ borderRadius: '5px', mx: 2, my: 2 }}>
        <Stack>
          <OverdueListPage employee />
        </Stack>
      </Card>
    </>
  );
};
export { EmployeeOverdueTasks };
